export { EloMinusIcon } from './minus-icon'
